import React from 'react';
import { Pill } from './Pill';

interface Props {
    title: string;
    body?: string;
    colour?: React.ComponentPropsWithoutRef<typeof Pill>['colour'];
}

export default function Alert({ title, body, colour = 'PURPLE' }: Props) {
    return (
        <div className="p-2">
            {!body && <Pill title={title} colour={colour} />}
            {body && (
                <div className="inline-flex items-center bg-white leading-none text-purple-600 rounded-full p-2 shadow text-teal text-sm">
                    <Pill title={title} colour={colour} />
                    <span className="inline-flex px-2">{body}</span>
                </div>
            )}
        </div>
    );
}
